import { STATIC_TOKENS } from '../../../../theme/index.content';
import {
  BorderGradientTokens,
  BorderWidthTokens,
} from '../../../../theme/index.types';
import { OUTLINE_STYLES } from './BoxOutlineGradient.content';

export const applyGradientStyles = (
  gradient: BorderGradientTokens,
  gradientWidth: BorderWidthTokens,
) => ({
  ...OUTLINE_STYLES,
  padding: STATIC_TOKENS.borderWidths[gradientWidth],
  background: `var(--${gradient})`,
});
